module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/02-c3089b66f518eac8fd7ea55decc4328f.png";